import {Component} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DcpConfiguratorLoadingStagesToCheckoutComponent} from '@dcp/configurator';

@UntilDestroy()
@Component({
  selector: 'dcp-express-checkout-page',
  templateUrl: './express-checkout-page.component.html',
  styleUrl: './express-checkout-page.component.scss',
  imports: [DcpConfiguratorLoadingStagesToCheckoutComponent],
})
export class ExpressCheckoutPageComponent {}
